import clsx from 'clsx'
import { forwardRef, type ReactNode } from 'react'

type DividedContentProps = {
  children: ReactNode
  className?: string
  theme?: 'blue' | 'beer'
  condensed?: boolean
}

export const DividedContent = forwardRef<HTMLDivElement, DividedContentProps>(
  ({ children, className, theme, condensed }, ref) => {
    const divideColorClass =
      theme === 'blue'
        ? 'divide-fv-blue-300'
        : theme === 'beer'
          ? 'divide-fv-beer-medium'
          : 'divide-fv-gray'

    return (
      <div
        ref={ref}
        className={clsx(
          'flex items-center divide-x [&>*:first-child]:pl-0 [&>*:last-child]:pr-0 [&>button+button]:ml-0',
          divideColorClass,
          className,
          !condensed ? '[&>*]:px-3' : '[&>*]:px-2',
        )}
      >
        {children}
      </div>
    )
  },
)
